import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import dayjs from "dayjs"

const header = [
	[
		"Template 11 - Claim counts by approved claim and rejected claim with reason"
	],
	["Number of claim counts", "", "Standard Plan", "Flexi Plan"]
]

/**
 * @param {*} claims
 * @param {*} status === "paid" || "rejected"
 * @param {*} plan  === "standard" || "flexi"
 */
const countClaim = (claims, isApproved, plan) => {
	if (isApproved) {
		return claims?.filter(claim => {
			let matchPlan = claim?.policy?.product?.productId?.plan?.includes(plan)

			if (claim.status === "APPROVED" && matchPlan) return claim
			if (claim.status === "Approved" && matchPlan) return claim
		}).length
	} else
		return claims?.filter(claim => {
			let matchPlan = claim?.policy?.product?.productId?.plan?.includes(plan)
			if (claim.status === "REJECTED" && matchPlan) return claim
			if (claim.status === "Rejected" && matchPlan) return claim
		}).length
}

/**
 * Helper that counts claim by total rejection code occurence
 */
const countClaimByRejectionCode = (list, code, plan) => {
	const output = list?.filter(claim => {
		const codes =
			claim.rejectionCodes !== null
				? claim.rejectionCodes?.map(item => item.code)
				: null
		let matchPlan = claim?.policy?.product?.productId?.plan?.includes(plan)

		if (codes === null && matchPlan) return
		else if (codes?.includes(code) && matchPlan) return true
	}).length
	return output
}

const rows = payload => {
	const paidClaims = [
		"Paid claims",
		"",
		countClaim(payload, true, "S00027"),
		countClaim(payload, true, "F00038")
	]

	const rejectedClaims = [
		"Rejected claims (paid amount = 0)",
		"",
		countClaim(payload, false, "S00027"),
		countClaim(payload, false, "F00038")
	]

	const rejectionCodes = [
		{ code: "100", name: "General exclusion items" },
		{ code: "101", name: "Pre-existing conditions" },
		{ code: "102", name: "Unknown pre-existing conditions (year 1)" },
		{ code: "103", name: "Case-based exclusion" },
		{
			code: "104",
			name: "Not medically necessary investigation(s)/ treatment(s)"
		},
		{ code: "105", name: "Unnecessary Hospitalisation" },
		{ code: "106", name: "Not/exceeded Reasonable ad Customary Charges" },
		{
			code: "107",
			name:
				"Exceed Limit (itemised benefit limit(s), annual overall limit, lifetime limit)"
		},
		{
			code: "108",
			name: "Expenses paid by other insurance plans/third parties"
		},
		{
			code: "109",
			name:
				"Services not rendered by non-eligible healthcare services providers"
		},
		{ code: "110", name: "General check-ups/wellness program/ immunisations" },
		{
			code: "111",
			name: "Services rendered by non-eligible healthcare services provider"
		},
		{
			code: "200",
			name: "Congnital conditions (Applicable for specific ages)"
		},
		{ code: "300", name: "No original receipt(s)" },
		{ code: "301", name: "Incomplete claim form" },
		{ code: "302", name: "Missing diagnosis" },
		{
			code: "303",
			name:
				"Close case due to no reply of requested information within the agreed period"
		},
		{ code: "400", name: "Material non-disclosure" },
		{ code: "401", name: "Fraudulent case" },
		{ code: "402", name: "Late claim submission" },
		{
			code: "403",
			name: "Claims incurred outside the effective period of the policy"
		},
		{ code: "900", name: "Other claim decline reason" }
	]

	const rejectedClaimByReason = rejectionCodes?.map(item => {
		return [
			item.code,
			item.name,
			countClaimByRejectionCode(payload, item.code, "S00027"),
			countClaimByRejectionCode(payload, item.code, "F00038")
		]
	})

	let output = [paidClaims, rejectedClaims, ...rejectedClaimByReason]

	return output
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate11Payload($claimWhere: claimWhereInput) {
			claims(where: $claimWhere) {
				list {
					status
					rejectionCodes {
						code
						name
					}
					policy {
						product {
							productId {
								plan
							}
						}
					}
				}
			}
		}
	`

	const variables = {
		claimWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.claims?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = [
		{ wpx: 50 },
		{ wpx: 500 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 1, c: 0 },
			e: { r: 1, c: 1 }
		},
		{
			s: { r: 2, c: 0 },
			e: { r: 2, c: 1 }
		},
		{
			s: { r: 3, c: 0 },
			e: { r: 3, c: 1 }
		}
	]

	return { workSheetData, workSheetColumns, workSheetMerges }
}
